import { render, staticRenderFns } from "./ManageStrippingOrder.vue?vue&type=template&id=574ab87f&scoped=true"
import script from "./ManageStrippingOrder.vue?vue&type=script&lang=js"
export * from "./ManageStrippingOrder.vue?vue&type=script&lang=js"
import style0 from "./ManageStrippingOrder.vue?vue&type=style&index=0&id=574ab87f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574ab87f",
  null
  
)

export default component.exports